import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import {
  Stack,
  Inline,
  Text,
  styleHelpers
} from '@leroy-merlin-br/backyard-react-ui'

const checkListStyles = ({ theme }) => css`
  label: checklist;
  display: none;

  margin-top: ${theme.spacings.bit};
  margin-bottom: ${theme.spacings.kilo};

  ${styleHelpers.shadowDouble(theme)};

  width: 100%;

  padding: ${theme.spacings.mega};

  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.giga};

  animation: ${appearFromTop} .5s forwards;
`

const appearFromTop = keyframes`
    from {
      opacity: 0;
      transform: translateY(0);
    }
    to {
      opacity: 1;
      transform: translateY(14px);
    }
`

const itemStyles = ({ theme }) => css`
  label: item;
  color: ${theme.colors.n900};

  svg {
    color: ${theme.colors.n300};
  }
`

const validStyles = ({ theme, isValid }) =>
  isValid &&
  css`
    label: item--valid;
    color: ${theme.colors.g600};

    svg {
      color: ${theme.colors.g600};
    }
  `

const visibleStyles = ({ isVisible }) =>
  isVisible &&
  css`
    label: checklist--visible;
    display: block;
    margin-top: 0;
`

const titleStyles = ({ theme }) => css`
  display: block;
  margin-bottom: ${theme.spacings.byte};
`

export const CheckList = styled(Stack)(checkListStyles, visibleStyles)
export const Item = styled(Inline)(itemStyles, validStyles)
export const Title = styled(Text)(titleStyles)
